import React from "react";
import { BrowserRouter as Router} from "react-router-dom"
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { NavTop } from "./components/navtop/navtop";
import { AuthProvider } from './context/AuthContext';
import RouterWapper from './router/Router';

function App() {
  return (
      <Router>
        <AuthProvider>
          <div className="App">
            <NavTop className="navTop"/>
            <RouterWapper />
          </div>
        </AuthProvider>
      </Router>
  );
}

export default App;
